import { SESSION_STORE } from "@/config/constConfig";

interface sessionJson {
    expireTime: number,  //过期时间
    value: any,  //session数据
}

/**获取session数据 */
export function getSessionData(sessionKey: string): any {
    let result: any = sessionStorage.getItem(sessionKey);
    if (result) {
        result = JSON.parse(result);
        if (new Date().getTime() < result.expireTime) {
            return result.value;
        }
    }
    return null;
}

/**设置session存储 */
export function setSessionData(sessionKey: string, value: any) {
    let store: any = SESSION_STORE;
    let sessionConfig = store[sessionKey];
    if ((value || value >= 0) && sessionConfig) {
        let tempJson: sessionJson = {
            expireTime: new Date().getTime() + sessionConfig.expireTime,
            value: value,
        }
        sessionStorage.setItem(sessionKey, JSON.stringify(tempJson));
    }
}